import { render, staticRenderFns } from "./BookingAwaitingApproval.vue?vue&type=template&id=517c370e&scoped=true"
import script from "./BookingAwaitingApproval.vue?vue&type=script&lang=js"
export * from "./BookingAwaitingApproval.vue?vue&type=script&lang=js"
import style0 from "./BookingAwaitingApproval.vue?vue&type=style&index=0&id=517c370e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c370e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VImg,VTooltip})
